var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 360",
    width: 2500,
    height: 2500
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.7 179.5c0 96.8-78.5 175.3-175.3 175.3-96.8 0-175.3-78.5-175.3-175.3C4.1 82.7 82.6 4.2 179.4 4.2c96.8 0 175.3 78.5 175.3 175.3z",
    fill: "#ca2127"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.7 62.9c-49.4 5.3-98.6 43.3-100.6 97.7-1.3 33.2 12.6 58.1 45.8 65.1 3.8-15.7 4.5-24.2 4.5-24.2s-14.6-14-16.1-22.9C86.1 107 185 58.1 236.9 108.1c35.8 34.7 12.2 141.4-45.6 130.3-55.4-10.6 27.1-95.5-17.1-112.2-35.9-13.6-55 41.5-38 68.8-10 47-31.5 91.3-22.8 150.2 28.3-19.5 37.8-56.9 45.6-95.9 14.2 8.2 21.8 16.8 39.9 18.1 66.8 4.9 104.1-63.5 95-126.7-8.2-56-66.8-84.5-129.2-77.8z",
    fill: "#fff"
  })));
}

export default SvgPinterest;